/**
 * Document view component.
 * @module components/theme/View/DefaultView
 */

import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Container } from 'semantic-ui-react';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';

import { hasBlocksData, getBaseUrl } from '@plone/volto/helpers';
import { isEqual } from 'lodash';
import { Attachments, CustomerSatisfaction, ShareBar } from '../';
import ContextNavigation from '@plone/volto/components/theme/Navigation/ContextNavigation'

/**
 * Component to display the default view.
 * @function DefaultView
 * @param {Object} content Content object.
 * @returns {string} Markup of the component.
 */
const DefaultView = (props) => {
  const { content, location } = props;
  const path = getBaseUrl(location?.pathname || '');
  const contentLoaded = content && !isEqual(Object.keys(content), ['lock']);

  const segments = path.split('/').filter(Boolean);
  const levelOnePath =
    segments.length >= 1 ? `/${segments[0]}` : '/';

  return contentLoaded ? (
    hasBlocksData(content) && (
      <>
        <div className='mainColumns'>

          <div className="contentColumn">
            <div id="page-document" className="pageBlocks">
              <RenderBlocks {...props} path={path} />
            </div>
            <Attachments {...content} />
            <ShareBar />
          </div>

          {!content.hide_context_navigation && (<ContextNavigation params={{ root_path: levelOnePath, includeTop: false, bottomLevel: 3 }} />)}
          
        </div>
        <CustomerSatisfaction {...content} />
      </>
    )) : null;
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
DefaultView.propTypes = {
  /**
   * Content of the object
   */
  content: PropTypes.shape({
    /**
     * Title of the object
     */
    title: PropTypes.string,
    /**
     * Description of the object
     */
    description: PropTypes.string,
    /**
     * Text of the object
     */
    text: PropTypes.shape({
      /**
       * Data of the text of the object
       */
      data: PropTypes.string,
    }),
  }).isRequired,
};

export default injectIntl(DefaultView);
